<template>
    <span
        :data-placement="placement"
        :data-original-title="title"
        class="ui-bstooltip"
    >
        <template v-if="$slots.default"><slot /> </template>
        <span v-else>
            {{ more }}
        </span>
    </span>
</template>
<script>
let BSTooltip = null

export default {
    name: 'BSTooltip',
    props: {
        placement: {
            type: String,
            default: 'bottom'
        },
        more: {
            type: String,
            default: 'Dowiedz się więcej'
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            instance: null
        }
    },
    watch: {
        title() {
            this.update()
        }
    },
    beforeMount() {
        if (typeof window !== 'undefined') {
            BSTooltip = require('bootstrap.native/dist/components/tooltip-native.esm.js')
        }
    },
    mounted() {
        if (!this.instance && BSTooltip) {
            this.instance = new BSTooltip.default(this.$el)
        }
    },
    beforeDestroy() {
        if (this.instance) {
            this.instance.dispose()
        }
    },
    methods: {
        update() {
            if (this.instance) {
                this.instance.update()
            }
        }
    }
}
</script>
<style lang="scss">
.ui-bstooltip {
    span {
        text-decoration: underline;
    }
}
</style>
